import CustomIcons from '../GlobalComponents/CustomIcons';
import React, { Component } from 'react'

class WhatsAppButton extends Component {

  render() {
    return (
      <a href="https://api.whatsapp.com/send?phone=573336495765" className="float" target="_blank">
        {/* <a href="https://api.whatsapp.com/send?phone=573336495765" > */}
        <CustomIcons icon='whatsappLogo'/>
      </a>
    )
  }
}

export default WhatsAppButton;